export default __webpack_public_path__ + "static/media/Compiler.24b5f182.png";